// Props for the reason-for-change field.
export interface ReasonVariantProps {
  value: string;
  onChange: (value: string) => void;
  isInvalid?: boolean;
}

export const REASON_PLACEHOLDER = "Why are you making this change?";
